<template>
  <div id="allbots">
    <div id="main">
      <!-- $store.state.userid -->
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Link Copied') }}!</v-snackbar
      >
      <div>
        <div>
          <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; height: 100vh">
            <vue-particles
              color="#ffffff"
              :particle-opacity="0.27"
              :particles-number="24"
              shape-type="circle"
              :particle-size="3"
              lines-color="#ffffff"
              :lines-width="1.1"
              :line-linked="true"
              :line-opacity="0.33"
              :lines-distance="192"
              :move-speed="1.6"
              :hover-effect="false"
              :click-effect="false"
            ></vue-particles>
          </div>
          <div v-show="!isLoading" class="accounts" style="z-index: 2">
            <v-toolbar flat color="transparent" style="background: transparent">
              <v-toolbar-title>
                <img
                  :src="$store.state.theme.small_logo"
                  class="responsive-img"
                  style="max-height: 25px; margin-top: 15px; margin-left: 20px"
                  alt
                />
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <div v-if="$store.state.userid == 'zwizadmin'" class="form-control">
                <div class="hidden-xs-only">
                  <v-layout>
                    <input
                      v-model="search"
                      type="text"
                      :placeholder="$t('Search')"
                      class="mb-0 pa-1"
                      style="line-height: 21px"
                      :disabled="loading"
                      @blur="onSearch"
                      @keyup.enter="$refs.searchbtn.$el.click()"
                    />
                    <v-btn
                      ref="searchbtn"
                      small
                      fab
                      depressed
                      color="primary"
                      :loading="loading"
                      @click="onSearch"
                    >
                      <v-icon small>search</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <div class="hidden-sm-and-up">
                  <v-btn small fab depressed color="primary" @click="showSearch = true">
                    <v-icon small>search</v-icon>
                  </v-btn>
                  <v-dialog v-model="showSearch" max-width="600">
                    <v-card>
                      <div class="text-xs-right">
                        <v-btn small fab flat @click="showSearch = false"
                          ><v-icon>close</v-icon></v-btn
                        >
                      </div>
                      <v-card-text>
                        <div class="form-control">
                          <input
                            v-model="search"
                            type="text"
                            :placeholder="$t('Search')"
                            class="mb-0 pa-1"
                            style="line-height: 21px"
                            :disabled="loading"
                            @blur="onSearch"
                          />
                        </div>
                        <div class="text-xs-center">
                          <v-btn depressed color="primary" :loading="loading" @click="onSearch">
                            <v-icon small>search</v-icon> {{ $t('Search') }}
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
              <change-password></change-password>

              <!-- <router-link
                :to="'/' + $i18n.locale() + '/partner'"
                class="link link-white"
                style="font-size: 18px"
                v-if="$store.state.partner_code && selectedBot.pagetype !== 'enterprise'"
              >
                <v-btn depressed color="green" dark style="line-height: 10px">
                  <v-icon class="mr-2" small>stars</v-icon>Partner Portal
                </v-btn>
              </router-link> -->

              <v-btn
                flat
                fab
                icon
                small
                class="hidden-sm-and-up"
                style="line-height: 10px"
                @click="logout"
              >
                <v-icon>power_settings_new</v-icon>
              </v-btn>
              <v-btn
                flat
                class="primary hidden-xs-only mr-4"
                style="line-height: 10px"
                @click="logout"
                >{{ $t('Sign Out') }}</v-btn
              >
              <lang-dropdown></lang-dropdown>
            </v-toolbar>

            <div class="text-xs-center">
              <h3 class="display-2 mt-4" style="color: white">{{ $t('Select bot to manage') }}</h3>
            </div>

            <v-container>
              <!--               <div class="text-xs-center" v-if="botlist.length >= size ">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </div>-->
              <v-layout
                wrap
                justify-center
                fill-height
                class="select-page"
                style="position: relative; margin-bottom: 35px"
                :class="{ 'no-bot': !botlist || botlist.length == 0 }"
              >
                <template v-for="bot in showBotList">
                  <v-flex
                    :key="'bot_' + bot.pageid"
                    xs6
                    sm4
                    md3
                    lg2
                    class="page pa-3"
                    style="cursor: pointer; position: relative"
                  >
                    <v-responsive
                      :aspect-ratio="1 / 1"
                      class="page-image"
                      @click="onSelectedBot(bot)"
                    >
                      <img
                        :src="pageProfile(bot)"
                        :alt="bot.pagename"
                        :title="bot.pagename"
                        style="width: 100%; border-radius: 10px"
                        @error="imgError"
                      />
                    </v-responsive>
                    <div
                      class="page-name text-xs-center white--text mt-2 mb-2 text-truncate"
                      :title="bot.pagename"
                      @click="onSelectedBot(bot)"
                    >
                      {{ bot.pagename }}
                    </div>
                    <v-btn
                      v-if="
                        $store.state.userid == 'zwizadmin' || $store.state.userid.includes('zwiz')
                      "
                      v-clipboard:copy="bot.pageid"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      fab
                      color="primary"
                      depressed
                      small
                      class="extra-small"
                      style="position: absolute; right: 0; top: 0"
                    >
                      <v-icon>file_copy</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-dialog
                  v-model="isAdd"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template #activator="{ on }">
                    <v-flex
                      v-if="isFacebook"
                      xs6
                      sm4
                      md3
                      lg2
                      class="page pa-3"
                      style="cursor: pointer"
                      v-on="on"
                    >
                      <v-responsive aspect-ratio="1:1">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/page-plus.svg'"
                          style="min-width: 100%"
                          height="auto"
                          fill="white"
                          class="page-image"
                        />
                      </v-responsive>

                      <div class="page-name text-xs-center white--text mt-2 mb-2">
                        {{ $t('Add') }}
                      </div>
                    </v-flex>
                  </template>

                  <v-card>
                    <template v-if="$store.state.isLoggedIn">
                      <div id="get-started">
                        <get-started @close="isAdd = false"></get-started>
                      </div>
                    </template>
                  </v-card>
                </v-dialog>
              </v-layout>
              <!-- {{botlist}} -->
              <v-btn
                v-if="showBotList && showBotList.length >= 100"
                :loading="loading"
                :disabled="loading"
                x-large
                block
                outline
                color="white"
                @click="getMore"
                >MORE</v-btn
              >
              <!--               <div class="text-xs-center" v-if="botlist.length >= size">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </div>-->
            </v-container>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showSupport" scrollable max-width="600" persistent>
      <v-card>
        <div class="text-xs-center pa-2 pt-3">
          <div class="title primary--text">{{ $t('You want to use a Redeem Code') }}</div>
          <div
            class="pa-2 my-2 mx-auto"
            style="background: #eee; border-radius: 50px; max-width: 400px"
          >
            {{ supportcode }}
          </div>
          {{ $t('with page') }}
        </div>
        <v-divider />
        <v-card-text max-height="600">
          <template v-for="(bot, index) in botlist">
            <div :key="bot.pageid" class="pa-2">
              <v-layout>
                <v-avatar :size="50">
                  <img
                    :src="
                      'https://graph.facebook.com/' +
                      bot.pageid +
                      '/picture?width=100&height=100&SameSite=None'
                    "
                  />
                </v-avatar>
                <v-flex class="pa-2">{{ bot.pagename }}</v-flex>
                <v-btn
                  color="primary"
                  :loading="loadingSupport"
                  small
                  depressed
                  @click="useRedeemCode(bot.pageid)"
                  >{{ $t('Apply') }}</v-btn
                >
              </v-layout>
            </div>
            <v-divider v-if="botlist.length - 1 != index" :key="bot.pageid + '_divider'" />
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :loading="loadingSupport"
            @click="
              showSupport = false
              clearSupportCode()
            "
            >{{ $t("I don't want to use it for now") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import { mapGetters } from 'vuex'

import LangDropdown from '@/components/elements/LangDropdown'
import GetStarted from '@/components/view/getstarted/GetStarted'
import ChangePassword from './ChangePassword.vue'
import { PAGE } from '../../../constants/page'

export default {
  components: {
    GetStarted,
    LangDropdown,
    ChangePassword
  },
  data: function () {
    return {
      pageNumber: 1,
      size: 60,
      pagelist: this.$store.state.pagelist,
      isLoading: true,
      isAdd: false,
      themelist: [],
      search: '',
      botCount: 0,
      showCopy: false,
      loading: false,
      botFound: [],
      showSupport: false,
      supportcode: '',
      loadingSupport: false,
      loadingSearch: false,
      showSearch: false,
      showBotList: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang'
    }),
    filterBots() {
      if (this.search.length && this.botFound.length) {
        return this.botFound
      } else {
        return this.botlist
      }
    },
    // filterBots: function() {
    //   let vm = this

    //   var b = []
    //   if (vm.search === '') {
    //     b = vm.botlist
    //   } else {
    //     b = vm.botlist.filter(bot => {
    //       return (
    //         bot.pagename.toLowerCase().includes(vm.search.toLowerCase()) ||
    //         bot.pageid.includes(vm.search.toLowerCase())
    //       )
    //     })
    //   }

    //   this.botCount = b.length

    //   const start = (this.pageNumber - 1) * this.size
    //   const end = start + this.size
    //   return b.slice(start, end)
    // },
    pageCount: function () {
      let l = this.botCount
      let s = this.size
      return Math.ceil(l / s)
    },
    nestleAcommerceGroup() {
      return (
        ['nestle'].includes(this.selectedBot.type) &&
        this.$store.state.admingroupid &&
        this.$store.state.admingroupid === '420'
      )
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal && !newVal.length) this.botFound = []
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  },
  mounted: function () {
    let vm = this
    vm.$store.dispatch('loading')

    if (this.$route.query.supportcode) this.supportcode = this.$route.query.supportcode
    vm.showBotList = vm.$store.state.botlist
    vm.getAllPublicTheme(function () {
      vm.$store.dispatch('updatePagelist')

      if (vm.isFacebook) {
        let pageidlist = vm.pagelist
          .map((val) => {
            if (val.perms) {
              if (val.perms.indexOf('ADMINISTER') > -1 || val.perms.indexOf('EDIT_PROFILE') > -1) {
                return val.id
              }
            }
            if (val.tasks) {
              if (val.tasks.indexOf('MANAGE') > -1 || val.tasks.indexOf('CREATE_CONTENT') > -1) {
                return val.id
              }
            }
            return null
          })
          .filter(Boolean)

        let data = {
          userid: vm.$store.state.userid,
          pageidlist: pageidlist,
          access_token: vm.$store.state.fbAccessToken
        }
        vm.$store.dispatch('getBotlist', data).then(
          () => {
            vm.$store.dispatch('loading')
            vm.isLoading = false
            if (!vm.botlist || vm.botlist.length <= 0) {
              vm.isAdd = true
            } else {
              if (vm.$route.query.supportcode) {
                vm.showSupport = true
              }
            }
          },
          (error) => {
            vm.$store.dispatch('loading')
            console.error(error)
          }
        )
      } else {
        vm.$store.dispatch('loading')
        vm.autoSelectPage()
        vm.isLoading = false
        if (!vm.botlist || vm.botlist.length <= 0) {
          vm.isAdd = true
        }
      }
    })
  },

  methods: {
    autoSelectPage() {
      const agentPages = PAGE.TTB_MAIN_PAGE
      if (this.$store.state.privilege && this.$store.state.privilege.role == 'agent') {
        const newBotList = this.$store.state.botlist.filter((x) => agentPages.includes(x.pageid))
        this.showBotList = newBotList
      }
    },
    pageProfile(bot) {
      let imgUrl = `https://graph.facebook.com/${bot.pageid}/picture?width=300&height=300&SameSite=None`
      if (bot.theme == 'summitcapital') {
        if (bot.pageid === '495271297476302') {
          //prod
          imgUrl =
            'https://zwizai.s3.amazonaws.com/ecommerce/1670383390836image-20221206-150255.png'
        } else if (['104337274602594', '106342852217021'].includes(bot.pageid)) {
          //uat
          imgUrl =
            'https://zwizai.s3.amazonaws.com/ecommerce/1672218178995summit-capital-uat-profile.png'
        }
      }
      return imgUrl
    },
    async useRedeemCode(pageid) {
      this.loadingSupport = true
      try {
        var response = await this.onSaveRedeem(pageid, this.supportcode)
        // console.log(response)
        var day = parseInt(response.extend)
        var latest_date = moment(response.expireat)
        response.package = response.isPass ? response.code : '-'

        if (response.responsecode == 200 && response.isPass) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('you got {day} days Premium Package', {
              day: day
            }),
            text: `${this.$t('Expired Date')} ${latest_date.format('DD/MM/YYYY')}`
          })
          this.clearSupportCode()
          location.reload()
        } else if (
          response.responsecode == 401 ||
          (response.responsecode == 200 && !response.isPass)
        ) {
          let time = response.unlocktimestamp
          await this.$swal.fire({
            type: 'error',
            title: this.$t('This page has too many attempt'),
            text: this.$t(`Please try again after`) + ' ' + moment(time).format('DD/MM/YYYY HH:mm')
          })
          this.$localStorage.set('redeemlock', time)
          this.clearSupportCode()
          this.showSupport = false
        }
      } catch (error) {
        console.error(error)
      }
      this.loadingSupport = false
    },
    onSaveRedeem(pageid, code) {
      return new Promise((resolve) => {
        var data = { pageid: pageid, redeem: code.toUpperCase() }
        api.activateredeemcode(data, function (error, response) {
          if (response.responsecode == 200) {
            if (Object.hasOwnProperty.call(response, 'extend')) {
              response.isPass = true
              response.code = code
              resolve(response)
            } else {
              response.isPass = false
              response.code = code
              resolve(response)
            }
          } else if (response.responsecode == 401) {
            response.isPass = false
            response.code = code
            resolve(response)
          }
        })
      })
    },
    clearSupportCode() {
      // remove support code
      var query = { ...this.$route.query }
      delete query.supportcode
      this.$router.push({
        path: '/' + this.currentLang + '/allbots',
        query: query
      })
    },
    onSearch() {
      let vm = this
      let data = { limit: 100, offset: 0, pagename: vm.search.toLowerCase() }
      vm.loading = true

      api.zwizadminbotlist(data, (err, response) => {
        vm.botFound = response.botlist
        vm.loading = false
        vm.showSearch = false
        vm.$store.commit('SET_BOTLIST', vm.botFound)
      })
    },
    getMore() {
      let vm = this
      let data = { limit: 100, offset: vm.botlist.length }
      vm.loading = true

      api.zwizadminbotlist(data, (err, response) => {
        vm.loading = false
        vm.botlist.push(...response.botlist)
        vm.$store.commit('SET_BOTLIST', vm.botlist)
      })
    },
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },

    onSelectedBot: function (bot) {
      try {
        this.$store.dispatch('selectBot', bot)
        var menubypageid = this.$store.state.menubypageid
        var pageid = this.selectedBot.pageid
        var theme = this.selectedBot.theme
        var privilege = this.$store.state.privilege
      } catch (error) {
        console.error(error)
      }

      if (menubypageid[pageid]) {
        this.$router.push(menubypageid[pageid][0])
      } else if (
        theme == 'ticket' ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if (['208321456497173'].includes(pageid) /* AIS FIBRE */) {
          this.$router.push('allinonechat')
        } else if (['nestle'].includes(this.selectedBot.type) && this.nestleAcommerceGroup) {
          return this.$router.push('template')
        } else {
          return this.$router.push('ticket')
        }
      } else {
        this.$router.push('welcome')
      }
      if (theme === 'ttb') {
        if (privilege && privilege.role) {
          if (['all', 'agent'].includes(privilege.role)) {
            // return this.$router.push('nongtungjai/patient-history')
            return this.$router.push({ name: 'ttb-profile', path: 'profile' })
          } else if (['qa', 'reporter'].includes(privilege.role)) {
            // return this.$router.push('nongtungjai/patient-history')
            return this.$router.push('ticket')
          } else {
            return this.$router.push('welcome')
          }
        }
      }
    },
    logout: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    getAllPublicTheme: function (callback) {
      let vm = this
      vm.themelist = [
        {
          themeid: 'ecommercebasic',
          themename: 'ecommercebasic',
          description: '',
          themepic: '',
          ispublic: true
        }
      ]
      callback()
    },
    selectBot: function (pageid) {
      const bot = this.botlist.find((bot) => {
        return bot.pageid == pageid
      })
      this.$store.dispatch('selectBot', bot)
    },
    imgError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon {
  line-height: 0 !important;
  height: 0 !important;
}
.select-page {
  .page {
    transition: transform 0.3s ease-out;

    &:hover {
      transform: translate(0, -5px);

      .page-image img {
        box-shadow: 0px 3px 5px #00000021;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/Account.vue